export class ChartPercentiles {
  public failed: number = 0;
  public initialSuccess: number = 0;
  public topPerformers: number = 0;
}
